/** Stored in Firestore `Students.status` */
export const STUDENT_STATUS = {
  ACTIVE: 'Active',
  ACTIVE_LISTENER: 'ActiveListener',
  INACTIVE: 'InActive',
};

/** True for regular Active and Active (listener) — both count as “active” for attendance, dashboards, etc. */
export function isActiveLikeStatus(status) {
  const s = status || STUDENT_STATUS.ACTIVE;
  return s === STUDENT_STATUS.ACTIVE || s === STUDENT_STATUS.ACTIVE_LISTENER;
}

/** Human-readable label for chips and UI */
export function getStudentStatusLabel(status) {
  const s = status || STUDENT_STATUS.ACTIVE;
  if (s === STUDENT_STATUS.ACTIVE_LISTENER) return 'Active (listener)';
  if (s === STUDENT_STATUS.INACTIVE) return 'Inactive';
  return s;
}

/** Father name field captions: female students use father/husband wording. */
export function getFatherNameFieldLabels(gender) {
  const isFemale = (gender || '').trim().toLowerCase() === 'female';
  if (isFemale) {
    return {
      english: 'Father/Husband Name',
      urdu: 'Father/Husband Name (Urdu)',
    };
  }
  return {
    english: 'Father Name',
    urdu: 'Father Name (Urdu)',
  };
}
